export const cibNginx = ["32 32","<path d='M16 0l-13.86 8v16l13.86 8 13.86-8v-16zM24 22.12c0 0.943-0.86 1.719-2.036 1.719-0.844 0-1.803-0.339-2.401-1.079l-8-9.52v8.88c0 0.959-0.76 1.719-1.703 1.719h-0.1c-0.963 0-1.719-0.803-1.719-1.719v-12.24c0-0.943 0.839-1.719 2-1.719 0.86 0 1.839 0.339 2.437 1.079l7.959 9.52v-8.88c0-0.963 0.803-1.719 1.724-1.719h0.099c0.959 0 1.719 0.797 1.719 1.719v12.24z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-nginx.js
// module id = null
// module chunks = 